import $ from 'jquery'
import { Util } from 'bootstrap'

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'value'
const DATA_KEY = `opp.${NAME}`
const EVENT_KEY = '.' + DATA_KEY
const DATA_API_KEY = '.data-api'
const JQUERY_NO_CONFLICT = $.fn[NAME]

const Selector = {
  DATA_TOGGLE_INPUT: '[data-toggle^="value"][data-toggle~="input"]',
  DATA_TOGGLE_CHANGE: '[data-toggle^="value"][data-toggle~="change"]',
  FIRST_CHILD: ':scope > :not(input), :not(input)'
}

const Event = {
  INPUT_DATA_API: `input${EVENT_KEY}${DATA_API_KEY}`,
  CHANGE_DATA_API: `change${EVENT_KEY}${DATA_API_KEY}`
}

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class Value {
  constructor(element) {
    this._element = element
    this._update = element.tagName === 'INPUT' ? '_updateValue' : '_updateText'
  }

  // Public

  show(value) {
    this[this._update](value)
  }

  // Private

  _updateValue(value) {
    $(this._element).val(value)
  }

  _updateText(value) {
    $(this._element).text(value)
  }

  // Static

  static _jQueryInterface(config, ...args) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = new Value(this)
        $(this).data(DATA_KEY, data)
      }

      if (typeof config === 'string') {
        if (typeof data[config] === 'undefined') {
          throw new TypeError(`No method named "${config}"`)
        }

        data[config](...args)
      }
    })
  }
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

function toggleValue(event) {
  const selector = Util.getSelectorFromElement(this)
  const target = selector ?
    document.querySelector(selector) :
    this.querySelector(Selector.FIRST_CHILD)

  Value._jQueryInterface.call($(target), 'show', $(event.target).val())

  return true
}

$(document).on(Event.INPUT_DATA_API, Selector.DATA_TOGGLE_INPUT, toggleValue)
$(document).on(Event.CHANGE_DATA_API, Selector.DATA_TOGGLE_CHANGE, toggleValue)

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = Value._jQueryInterface
$.fn[NAME].Constructor = Value
$.fn[NAME].noConflict = () => {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return Value._jQueryInterface
}

export default Value
